import React from 'react';
import { Typography } from '@mui/material';

export const AftermarketProductsDashboard = () => {
  return (
    <Typography variant="h6">
      Please contact your TRNSACT Account Manager to set up your aftermarket product dashboard.
    </Typography>
  );
};
